// Module
var code = " <div ng-if=\"!$ctrl.showCard\" class=\"card-placeholder\" id=\"card_{{$ctrl.card.id}}\"> </div> <div ng-if=\"$ctrl.showCard\" id=\"card_{{$ctrl.card.id}}\" class=\"card\"> <nets-phone card=\"$ctrl.card\" context=\"card\"></nets-phone> </div>";
// Exports
export default code;